import LocalizedStrings from 'react-localization';
import {En} from "./En";
import {Da} from "./Da";


export default new LocalizedStrings({
  en: En,
  da: Da
});
